var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('VideoViewer',{attrs:{"src":'https://pcleonov-m710q.office.ki-wi.cz/WebDAV/v4.mp4'}}),(!_vm.show)?_c('Overlay',{attrs:{"startDelay":'5',"positionX":'10%',"positionY":'10%',"size":'50%'}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }